import React from 'react';
import { ReportData, DetailedFinding } from '../../types/report.types';
import BaseFindingEditor from './BaseFindingEditor';

interface InfoFindingsEditorProps {
    reportData: ReportData;
    onFindingChange: (index: number, field: keyof DetailedFinding, value: string) => void;
    onRemoveFinding: (index: number) => void;
    onAddFinding: (severity: 'Critical' | 'High' | 'Medium' | 'Low' | 'Info') => void;
}

const InfoFindingsEditor: React.FC<InfoFindingsEditorProps> = (props) => {
    return <BaseFindingEditor {...props} severity="Info" />;
};

export default InfoFindingsEditor;
